import './Like.scss';

import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import { ReactComponent as LikeIcon } from 'assets/icons/like.svg';

const Like = forwardRef(({ checked, onClick, disabled }, ref) => (
  <label className="like">
    <input
      type="checkbox"
      ref={ref}
      checked={checked}
      readOnly={!disabled}
      disabled={disabled}
      onClick={onClick}
    />
    <LikeIcon />
  </label>
));

Like.propTypes = {
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

Like.defaultProps = {
  checked: false,
  onClick: () => {},
  disabled: false,
};

export default Like;
